import React from "react";

export const DocTemplate = ({  w, h, color }) => {
  return (
    <svg
      width={w || '35'}
      height={h || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.12031 8.33234H6.08031C6.33492 8.33234 6.5791 8.2312 6.75914 8.05117C6.93917 7.87113 7.04031 7.62695 7.04031 7.37234C7.04031 7.11774 6.93917 6.87356 6.75914 6.69352C6.5791 6.51349 6.33492 6.41234 6.08031 6.41234H5.12031C4.86571 6.41234 4.62153 6.51349 4.44149 6.69352C4.26146 6.87356 4.16031 7.11774 4.16031 7.37234C4.16031 7.62695 4.26146 7.87113 4.44149 8.05117C4.62153 8.2312 4.86571 8.33234 5.12031 8.33234ZM5.12031 10.2523C4.86571 10.2523 4.62153 10.3535 4.44149 10.5335C4.26146 10.7136 4.16031 10.9577 4.16031 11.2123C4.16031 11.467 4.26146 11.7111 4.44149 11.8912C4.62153 12.0712 4.86571 12.1723 5.12031 12.1723H10.8803C11.1349 12.1723 11.3791 12.0712 11.5591 11.8912C11.7392 11.7111 11.8403 11.467 11.8403 11.2123C11.8403 10.9577 11.7392 10.7136 11.5591 10.5335C11.3791 10.3535 11.1349 10.2523 10.8803 10.2523H5.12031ZM15.6803 7.31474C15.6703 7.22655 15.651 7.13967 15.6227 7.05554V6.96914C15.5766 6.87044 15.515 6.7797 15.4403 6.70034L9.68031 0.940344C9.60096 0.865671 9.51022 0.804101 9.41151 0.757944C9.38286 0.753873 9.35377 0.753873 9.32511 0.757944C9.22759 0.702015 9.11989 0.666114 9.00831 0.652344H3.20031C2.43649 0.652344 1.70395 0.955772 1.16385 1.49588C0.62374 2.03598 0.320313 2.76852 0.320312 3.53234V16.9723C0.320312 17.7362 0.62374 18.4687 1.16385 19.0088C1.70395 19.5489 2.43649 19.8523 3.20031 19.8523H12.8003C13.5641 19.8523 14.2967 19.5489 14.8368 19.0088C15.3769 18.4687 15.6803 17.7362 15.6803 16.9723V7.37234C15.6803 7.37234 15.6803 7.37234 15.6803 7.31474ZM9.92031 3.92594L12.4067 6.41234H10.8803C10.6257 6.41234 10.3815 6.3112 10.2015 6.13117C10.0215 5.95113 9.92031 5.70695 9.92031 5.45234V3.92594ZM13.7603 16.9723C13.7603 17.227 13.6592 17.4711 13.4791 17.6512C13.2991 17.8312 13.0549 17.9323 12.8003 17.9323H3.20031C2.9457 17.9323 2.70153 17.8312 2.52149 17.6512C2.34146 17.4711 2.24031 17.227 2.24031 16.9723V3.53234C2.24031 3.27774 2.34146 3.03356 2.52149 2.85352C2.70153 2.67349 2.9457 2.57234 3.20031 2.57234H8.00031V5.45234C8.00031 6.21617 8.30374 6.94871 8.84385 7.48881C9.38395 8.02892 10.1165 8.33234 10.8803 8.33234H13.7603V16.9723ZM10.8803 14.0923H5.12031C4.86571 14.0923 4.62153 14.1935 4.44149 14.3735C4.26146 14.5536 4.16031 14.7977 4.16031 15.0523C4.16031 15.307 4.26146 15.5511 4.44149 15.7312C4.62153 15.9112 4.86571 16.0123 5.12031 16.0123H10.8803C11.1349 16.0123 11.3791 15.9112 11.5591 15.7312C11.7392 15.5511 11.8403 15.307 11.8403 15.0523C11.8403 14.7977 11.7392 14.5536 11.5591 14.3735C11.3791 14.1935 11.1349 14.0923 10.8803 14.0923Z"
        fill={color || 'url(#paint0_linear_4431_204236)'}
        stroke={color || 'url(#paint1_linear_4431_204236)'}
        stroke-width="0.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4431_204236"
          x1="3"
          y1="12.001"
          x2="21"
          y2="12.001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#775FD5" />
          <stop offset="1" stop-color="#F03A85" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4431_204236"
          x1="3"
          y1="12.001"
          x2="21"
          y2="12.001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#775FD5" />
          <stop offset="1" stop-color="#F03A85" />
        </linearGradient>
      </defs>
    </svg>
  );
};
